import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { DEFAULT_DOCUMENT_TITLE, WP_EMBED_DOCUMENT_TITLE } from "@constants/documentTitle.config";
import { isEmbedPortalSearch } from "@constants/embedPortal.config";

/**
 * Sets the browser tab title when the URL includes the WordPress embed query (`source=wp`).
 */
export function useEmbedPortalDocumentTitle(): void {
	const { search } = useLocation();

	useEffect(() => {
		document.title = isEmbedPortalSearch(search) ? WP_EMBED_DOCUMENT_TITLE : DEFAULT_DOCUMENT_TITLE;
	}, [search]);
}
